<template>
    <div id="pre-black-banner">
        <picture>
            <source :srcset="data.mobile" media="(max-width: 767px)" />
            <img :src="data.desktop" class="img-responsive" />
        </picture>
        <div class="form-wrapper">
            <template v-if="!registered">
                <form id="footer-promo-subscribe-banner">
                    <Alert :alert="newsletterAlert" :style="{ marginTop: '0px !important' }" />
                    <TextField
                        id="promo-footer-nome"
                        autocomplete="nome"
                        v-model="fields.name"
                        placeholder="Seu nome"
                        type="text"
                    />
                    <div class="input-mail-send">
                        <TextField
                            id="promo-footer-email"
                            autocomplete="email"
                            v-model="fields.email"
                            placeholder="Seu email"
                            type="email"
                            class="d-flex"
                            :style="{ width: '100%' }"
                        />
                        <LoadingButton
                            :loading="busy"
                            @click="subscribe"
                            class="btn btn-small text-uppercase send-btn disabled"
                        >
                            Enviar
                        </LoadingButton>
                    </div>
                </form>
            </template>
            <template v-else>
                <div class="send-btn-closed d-flex flex-justify-center flex-align-center">
                    <p>Seu e-mail foi cadastrado com sucesso!</p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import Alert from '../../common/Alert.vue';
    import TextField from '@bit/chicorei.chicomponents.input.text-field';
    import LoadingButton from '../../common/LoadingButton.vue';
    import { resizeOrientationAware } from '../../../../common/common';
    import { customerService } from '../../../../common/service/resource';

    export default {
        name: 'PreBlackBanner',
        props: {
            data: {
                type: Object,
                required: true,
            },
        },

        components: {
            Alert,
            TextField,
            LoadingButton,
        },

        data() {
            return {
                registered: false,
                busy: false,
                newsletterAlert: null,
                isMobile: false,
                fields: {
                    name: this.$scope.id ? this.$scope.CUSTOMER.NAME : null,
                    email: this.$scope.id ? this.$scope.CUSTOMER.EMAIL : null,

                    promo: true,
                    releases: true,
                    content: true,
                },
            };
        },

        mounted() {
            this.resizeAwareRemoveCb = resizeOrientationAware(() => this.onResize(), true);
        },

        beforeDestroy() {
            this.resizeAwareRemoveCb();
        },

        methods: {
            onResize() {
                this.isMobile = window.innerWidth < 768;
            },

            subscribe() {
                this.busy = true;

                let promise;
                if (this.$scope.id && this.$scope.CUSTOMER.EMAIL === this.fields.email) {
                    promise = customerService.update(this.$scope.id, {
                        news_promo: this.fields.promo,
                        news_colecao: this.fields.releases,
                        news_conteudo: this.fields.content,
                        unsubscribe: !(
                            this.fields.promo ||
                            this.fields.releases ||
                            this.fields.content
                        ),
                    });
                } else {
                    promise = this.axios.api.post('/get_response/subscribe', {
                        name: this.fields.name,
                        email: this.fields.email,
                        newsPromo: this.fields.promo,
                        newsColecao: this.fields.releases,
                        newsConteudo: this.fields.content,
                        page_subscribe: 'black-friday',
                        frequency: 1,
                    });
                }

                promise
                    .then(() => this.onNewsletterSuccess())
                    .catch((error) => this.onNewsletterFailed(error))
                    .then(() => (this.busy = false));
            },

            onNewsletterSuccess() {
                this.registered = true;
                this.newsletterAlert = {
                    message: 'Newsletter assinada com sucesso',
                };
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: 'subscribe-aniversario',
                });
            },

            onNewsletterFailed(error) {
                this.newsletterAlert = {
                    message: error.response.data.message || 'Não foi possível assinar a newsletter',
                    isError: true,
                };
            },
        },
    };
</script>
